import React, { Component } from 'react';
import { connect } from 'react-redux';
import {BreadCumb, DataTables, NavBar,TimeOut} from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient, ApiResponse } from '../../libs/apiClient';
import config from '../../config';
import $ from "jquery";
import moment from "moment";

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Serie", value: true },//0
    { title: "Estatus", value: true },//1
    { title: "Num.Doc", value: true },//2
    { title: "Cliente", value: true },//3
    { title: "Nombre", value: true },//4
    { title: "Fecha Cont.", value: true },//5
    { title: "Comentarios", value: true },//6
    { title: "Empl. Ventas", value: true },//7
    { title: "Titular Doc.", value: true },//8
    { title: "Total", value: true },//9
    { title: "Fecha Entrega/ Vencimiento", value: true },//10
    { title: "Referencia", value: true },//11
    { title: "Observacion del Estado", value: false },//12
    { title: "Estado del documento", value: false },//13
    { title: "Docs Vencidos", value: true },//14
    { title: "Facturado", value: true },//15
    { title: "Pagado", value: true },//16
    { title: "Vencido", value: true }];//17

class InvoiceReserveView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        }

    }

    async componentDidMount() {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liFactura");
        let today =  moment(new Date()).format('YYYYMMDD');

        let date= {
            dateInit:today,
            dateFinal:today,
        }

        await this.callDocumentsListService(date);
    }

    callDocumentsListService = async newDate => {

        const {notificationReducer:  { showAlert }, enableSpinner } = this.props;
        
        let data = {
            dateInit: newDate.dateInit,
            dateFinal: newDate.dateFinal,
            switch1 : newDate.docStatus || '---',
            groupCodeValue : newDate.groupCodeValue || '---',
            docSubType:"--",
            table: "OINVRI",
            docNumSearch: newDate.docNumSearch ? newDate.docNumSearch === '' ? '--' : newDate.docNumSearch : '--', 
            searchSerieName: newDate.searchSerieName ? newDate.searchSerieName === '' ? '--' : newDate.searchSerieName : '--'
        };
        enableSpinner(true);
        let invoiceListResponse = await apiClient.getDocumentsListInvoice(data);
        enableSpinner(false);
        if(invoiceListResponse.status === SERVICE_RESPONSE.SUCCESS){
            let dataSerie = {
                docType: "13",
                docSubType: "--"
            };
            if (invoiceListResponse.data.length === 0) {
                showAlert({
                    type: 'info',
                    timeOut: 5000,
                    message: "No se encontraron resultados correspondientes a la búsqueda."
                });

                this.setState({
                    data: [],
                });
                return;
            }

            enableSpinner(true);
            let seriesResponse = await apiClient.getSeries(dataSerie);
            enableSpinner(false);

            let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

            let ValidateSeries = user.U_FMB_ValidateSeriesOINV ? user.U_FMB_ValidateSeriesOINV : "";

            if (!user || ValidateSeries == "") {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
                });

                this.setState({
                    data: [],
                });
                return;
            }

            let seriesUsers = ValidateSeries.split("|");


            let newArraySeries = [];

            seriesUsers.map(serieUser => {
                seriesResponse.data.map(serieResponse => {
                    if (serieResponse.Series == serieUser  && serieResponse.ObjectCode === '13' && serieResponse.DocSubType == '--') {
                        newArraySeries.push(serieResponse);
                    }
                })
            })

            if (newArraySeries.length === 0) {
                showAlert({
                    type: 'warning',
                    timeOut: 5000,
                    message: "El usuario no tiene serie permitida de escritura y lectura"
                });
                return;
            }


            let newDocumentsfilterSeries = [];

            invoiceListResponse.data.map(document => {
                newArraySeries.map(serie => {
                    if(document.SeriesCode == serie.Series ){
                        newDocumentsfilterSeries.push(document);
                    }
                })
            });

            
            if(( newDate.docNumSearch && newDate.docNumSearch !== '--' ) || ( newDate.searchSerieName !== '--' && newDate.searchSerieName )){
                newDocumentsfilterSeries = invoiceListResponse.data;
            }
            this.setState({
                data: newDocumentsfilterSeries,
            });
            return;
        }

       // showAlert({type: 'error', message: invoiceListResponse.message});

    }


    searchDocuments = async date => {
        await this.callDocumentsListService(date);
    };

    render() {
        const {headers, data, updateData , _user} = this.state;
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <TimeOut/>
                <BreadCumb subitem1={'FACTURA DE RESERVA DE CLIENTES'} url1={'#'}/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;FACTURA DE RESERVA DE CLIENTES
                        </a>
                    </h2>
                    
                    <DataTables headers={headers} view={"invoiceReserve"} data={data} search={this.searchDocuments} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InvoiceReserveView);


